import Link from 'next/link';
 import Icon from'@/components/ui/AppIcon';

export default function Footer() {
  const currentYear = 2026

  const linkGroups = [
    {
      id: 'footer_about',
      title: 'About',
      links: [
        { id: 'about_mission', label: 'Our Mission', href: '#' },
        { id: 'about_team', label: 'Team', href: '#' },
        { id: 'about_contact', label: 'Contact', href: '#' },
      ],
    },
    {
      id: 'footer_saints',
      title: 'Saints',
      links: [
        { id: 'saints_search', label: 'Search Saints', href: '/search-saints' },
        { id: 'saints_daily', label: 'Saint of the Day', href: '/saint-of-the-day' },
        { id: 'saints_popular', label: 'Popular Saints', href: '/search-saints' },
      ],
    },
    {
      id: 'footer_resources',
      title: 'Resources',
      links: [
        { id: 'resources_blog', label: 'Blog', href: '/blog' },
        { id: 'resources_prayers', label: 'Prayers', href: '/blog' },
        { id: 'resources_calendar', label: 'Feast Day Calendar', href: '#' },
      ],
    },
    {
      id: 'footer_legal',
      title: 'Legal',
      links: [
        { id: 'legal_privacy', label: 'Privacy Policy', href: '#' },
        { id: 'legal_terms', label: 'Terms of Service', href: '#' },
      ],
    },
  ]

  const socialLinks = [
    { id: 'social_facebook', icon: 'ShareIcon', href: '#', label: 'Facebook' },
    { id: 'social_twitter', icon: 'ShareIcon', href: '#', label: 'Twitter' },
    { id: 'social_instagram', icon: 'ShareIcon', href: '#', label: 'Instagram' },
  ]

  return (
    <footer className="bg-card border-t border-border mt-24">
      <div className="max-w-7xl mx-auto px-6 py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {linkGroups.map((group) => (
            <div key={group.id}>
              <h3 className="text-sm font-semibold text-foreground mb-4 uppercase tracking-wider">
                {group.title}
              </h3>
              <ul className="space-y-3">
                {group.links.map((link) => (
                  <li key={link.id}>
                    <Link
                      href={link.href}
                      className="text-sm text-muted-foreground hover:text-primary transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
              <Icon name="SparklesIcon" size={20} className="text-white" />
            </div>
            <span className="text-sm text-muted-foreground">
              © {currentYear} SaintSeek. All rights reserved.
            </span>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            {socialLinks.map((social) => (
              <a
                key={social.id}
                href={social.href}
                aria-label={social.label}
                className="w-10 h-10 rounded-full bg-muted flex items-center justify-center hover:bg-primary hover:text-white transition-colors"
              >
                <Icon name={social.icon as any} size={20} />
              </a>
            ))}
          </div>
        </div>

        {/* Tagline */}
        <div className="text-center mt-8">
          <p className="text-xs text-muted-foreground italic font-serif">
            "Pray for us, all holy men and women"
          </p>
        </div>
      </div>
    </footer>
  )
}